import { render } from "./reduction.vue?vue&type=template&id=18e44fea&scoped=true"
import script from "./reduction.vue?vue&type=script&lang=js"
export * from "./reduction.vue?vue&type=script&lang=js"

import "./reduction.vue?vue&type=style&index=0&id=18e44fea&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e44fea"]])

export default __exports__